import {Injectable,ViewChild} from '@angular/core';
import {
    HttpRequest,
    HttpResponse,
    HttpErrorResponse,
    HttpHandler,
    HttpEvent,
    HttpInterceptor
} from '@angular/common/http';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/catch';
import {Events} from 'ionic-angular';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
    constructor(public events: Events) {
    }

    private applyCredentials(req) {
        return req.clone({
            headers: req.headers.set("Authorization", localStorage.getItem('token') || '')
        });
    };

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(this.applyCredentials(req))
            .do((event: HttpEvent<any>) => {
                if (event instanceof HttpResponse) {
                    if (event.body.per_auth == false) {

                        return;
                    }
                }
            })
            .catch((err) => {
                if (err instanceof HttpErrorResponse) {
                    if (err.status === 401) {
//                        console.log(err);
                        localStorage.removeItem('token');
                        localStorage.setItem('token', err.error.refresh_token);
                        return next.handle(this.applyCredentials(req));
                    }
                    else if (err.status === 400) {
                        localStorage.clear();
                        this.events.publish('redirect:LoginPage', true);
                    }
                }
            });
    }


}


// WEBPACK FOOTER //
// ./src/app/interceptor.ts